import { Button } from "react-bootstrap";
import BasicTooltip from "../Tooltip/BasicTooltip";
import { MdOutlineRefresh } from "react-icons/md";
import { useCallback } from "react";

const RefreshDocList = ({ className }) => {
    const refreshDocumentLists = useCallback(() => {
        const refreshEvent = new CustomEvent('refreshDocLists');
        window.dispatchEvent(refreshEvent);
    }, []);

    return (
        <BasicTooltip text="Refresh list" placement="top">
            <Button variant="outline-secondary" className={`refresh-button position-absolute ${className ?? "top-0 end-0"}`}>
                <MdOutlineRefresh
                    className="mytools_refresh_icon"
                    size={28}
                    style={{ cursor: "pointer" }}
                    onClick={() => refreshDocumentLists(false)}
                />
            </Button>
        </BasicTooltip>
    );
};

export default RefreshDocList;
